import {Directive, ElementRef, forwardRef, HostListener, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Directive({
  selector: '[phoneMaskForm]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneMaskDirective),
      multi: true
    }
  ]
})
export class PhoneMaskDirective implements ControlValueAccessor {
  private onChange = (value: any) => {};
  private onTouched = () => {};
  private isFocused = false;

  @Input() isFocusedCritical = false;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    const digits = this.extractDigits(value || '');

    if(!this.isFocusedCritical) {
      this.el.nativeElement.value = this.formatPhone(digits);
    } else {
      if (this.isFocused) {
        this.el.nativeElement.value = this.formatPhone(digits);
      } else {
        this.el.nativeElement.value = digits ? '+7' + digits : '';
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  @HostListener('focus')
  onFocus(): void {
    this.isFocused = true;
    const digits = this.extractDigits(this.el.nativeElement.value);
    this.el.nativeElement.value = this.formatPhone(digits);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const numeric = this.extractDigits(value);
    const formatted = this.formatPhone(numeric);

    input.value = formatted;
    this.onChange(numeric);
  }

  @HostListener('blur')
  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
    const input = this.el.nativeElement;
    const digits = this.extractDigits(input.value);
    if (!digits || digits.length == 1) {
      this.el.nativeElement.value = '';
    }
  }

  private extractDigits(value: string): string {
    return value?.replace(/\D/g, '').substring(0, 11);
  }

  private formatPhone(value: string): string {
    let result = '+7';

    if (value.length >= 2) result += ' (' + value.substring(1, 4);
    if (value.length >= 5) result += ') ' + value.substring(4, 7);
    if (value.length >= 8) result += '-' + value.substring(7, 9);
    if (value.length >= 10) result += '-' + value.substring(9, 11);

    return result;
  }
}
